const projects = [
  {
    id: 1,
    link: {
      href: "https://i.postimg.cc/DyrhFWWd/inventorysystem-demo.gif",
    },
    image: {
      src: "/projects/demos/inventory_system_demo.gif",
      alt: "InventorySystem - Home Page",
    },
    title: "InventorySystem",
    description:
      "InventorySystem was made for a local hardware shop. The system has users, categories, products, clients, sales and report sales modules.",
    technologies: [
		{
			id: 1,
			name: "Semantic HTML5",
		  },
		  {
			id: 2,
			name: "CSS3",
		  },
		  {
			id: 3,
			name: "jQuery",
		  },
		  {
			id: 4,
			name: "PHP",
		  },
		  {
			id: 5,
			name: "MySQL",
		  },
    ],
    summary:
      "The client requested PHP. They wanted PHP because they would maintain the code so it was created with the MVC architectural pattern.",
  },
  {
    id: 2,
    link: {
      href: "https://i.postimg.cc/c1KYDWKN/a-is-for-artisan-demo.gif",
    },
    image: {
      src: "/projects/demos/a_is_for_artisan_demo.gif",
      alt: "A is for Artisan - Home Page",
    },
    title: "A is for Artisan",
    description:
      "A is for Artisan is a non profit organization based in Washington DC that works to celebrate and promote Latin American craft.",
    technologies: [
      {
        id: 1,
        name: "Semantic HTML5",
      },
      {
        id: 2,
        name: "CSS3",
      },
      {
        id: 3,
        name: "Bulma CSS Framework",
      },
      {
        id: 4,
        name: "Gulp",
      },
      {
        id: 5,
        name: "WordPress",
      },
      {
        id: 6,
        name: "PHP",
      },
    ],
    summary:
      "The client requested WordPress. They wanted the ability to change, add and remove content on their site without the need for a developer.",
  },
  {
    id: 3,
    link: {
      href: "https://jmparedes.me/",
    },
    image: {
      src: "/projects/demos/portfolio_demo.gif",
      alt: "Juan Paredes's Portfolio - Home Page",
    },
    title: "Juan Paredes's Portfolio",
    description: "This is my first personal website (Portfolio).",
    technologies: [
      {
        id: 1,
        name: "Semantic HTML5",
      },
      {
        id: 2,
        name: "CSS3",
      },
      {
        id: 3,
        name: "SASS",
      },
      {
        id: 4,
        name: "ReactJS",
      },
      {
        id: 5,
        name: "JavaScript",
      },
    ],
    summary:
      "I was really interested in built it in ReactJS because I wanted speed and that's what ReactJS would offer to me.",
  },
];

export default projects;
